export enum ScheduleItemId {
  EditMultiSchedule = 'multiSiteEditSchedule',
  EditSchedule = 'editSchedule',
  OperationTile = 'editAdvancedSettings',
  Interlocking = 'relatedInterlocking',
  ShowAccess = 'showAccess',
}
